
<div class = "keep-appointment">

  <div class="appointment-details-summary">

    <h3>Résumé </h3>

    <h5>Véhicule </h5>

    <div class="appointment-detail-item"> <h6> Référence</h6> <h6> <b>{{currentAppointment.carMake }} {{currentAppointment.carModel }} {{currentAppointment.carVersion }}, {{currentAppointment.carYear}}</b></h6> </div>
    <!--
    <div class="appointment-detail-item"> <h6> Boite</h6> <h6> <b>{{currentAppointment.car.gearBox }}</b> </h6> </div>
    <div class="appointment-detail-item"> <h6> Carburant</h6> <h6> <b>{{currentAppointment.car.fuel }} </b> </h6> </div> -->
    <mat-divider></mat-divider>

    <h5>Rendez vous </h5>
    <div class="appointment-detail-item"> <h6> Date rdv</h6> <h6> <b>{{ dateFormat(currentAppointment.appointmentDate) }} </b></h6> </div>
    <div class="appointment-detail-item"> <h6> Lieu</h6> <h6> <b>{{currentAppointment.locationMode}} </b></h6> </div>
    <div class="appointment-detail-item"> <h6> Services</h6> <h6> <b> @for (serv of currentAppointment.services; track serv; let i = $index) {
    <span> <span [hidden]="i==0">,</span> {{serv}} </span>
  } </b></h6> </div>
  <div class="appointment-detail-item"> <h6> Prestations</h6> <h6> <b> @for (temp of currentAppointment.jobTemplates; track temp; let i = $index) {
  <span> <span [hidden]="i==0">,</span> {{temp.code}} - {{temp.title}}  </span>
} </b></h6> </div>
<div class="appointment-detail-item"> <h6> Catégorie serv</h6> <h6> <b> @for (categ of currentAppointment.jobCategories; track categ; let i = $index) {
<span> <span [hidden]="i==0">,</span> {{categ}} </span>
} </b></h6> </div>

<div class="appointment-detail-item"> <h6> Urgence</h6> <h6> <b>{{currentAppointment.emergency ? 'OUI ': 'NON '}} </b></h6> </div>

<mat-divider></mat-divider>
<h5>Vos infos </h5>
<div class="appointment-detail-item"><h6>Client</h6> <h6><b>{{ currentAppointment.customerCivility }} {{ currentAppointment.customerFirstName }} {{ currentAppointment.customerLastName }}</b></h6></div>
<div class="appointment-detail-item"><h6>Ville</h6> <h6><b>{{ currentAppointment.customerCity }}, {{ currentAppointment.customerCountry }} </b></h6></div>
<div class="appointment-detail-item"><h6>Telephone</h6> <h6><b>+{{ currentAppointment.customerPhoneNumber.code }} {{ currentAppointment.customerPhoneNumber.number }}  </b></h6></div>

</div>

<mat-stepper linear #stepper class="keep-stepper">

  <mat-step [stepControl]="carInfosForm.control" [editable]="isEditable">

    <ng-template matStepLabel>
      <h3>Votre voiture</h3>
    </ng-template>

    <div class="appointment-step">

      <form #carInfosForm="ngForm" class="">
        <h5>
          Nouvelle voiture ?
          <mat-slide-toggle
            class="example-margin"
            name = "newCar"
            [disabled]="false"
            [(ngModel)]="isNewCar"
            (change)="onNewCarChange()">

          </mat-slide-toggle>
        </h5>

        @if (!isNewCar) {
          <mat-form-field>
            <mat-label>Choisir voiture</mat-label>
            <mat-select required name = "car" [(ngModel)]="currentAppointment.carId" >
              @for (car of myKeepCars; track car; let i = $index) {
                <mat-option [value]="car.carId" >{{car.make}} {{car.model}} {{car.year}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if (isNewCar) {
          <div class="appointment-car">
            @if (isNewCar) {
              <mat-form-field>
                <mat-label>Marque</mat-label>
                <mat-select required name = "make" (selectionChange)="onMakeChange($event.value)" [(ngModel)]="selectedMake">
                  @for (make of makes; track make; let i = $index) {
                    <mat-option [value]="make" >{{make.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (isNewCar && currentAppointment.carMake !=='') {
              <mat-form-field >
                <mat-label>Modele</mat-label>
                <mat-select matNativeControl required name = "model" (selectionChange)="onModelChange($event.value)" [(ngModel)]="selectedModel">
                  @for (model of models; track model) {
                    <mat-option [value]="model" >{{model.makeName}} {{model.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (isNewCar && currentAppointment.carModel !=='') {
              <mat-form-field >
                <mat-label>Version</mat-label>
                <mat-select matNativeControl required name = "version" (selectionChange)="onVersionChange($event.value)" [(ngModel)]="selectedVersion">
                  @for (version of versions; track version) {
                    <mat-option [value]="version" >{{version.makeName}} {{version.modelName}} {{version.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            <!--
            <mat-form-field *ngIf="currentAppointment.car.version != ''">
              <mat-label>Année</mat-label>
              <mat-select matNativeControl required name = "year" [(ngModel)]="currentAppointment.car.year">
                <mat-option *ngFor="let year of carYearsBD;" [value]="year"> {{year}} </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="currentAppointment.car.version != ''">
              <mat-label>Boite</mat-label>
              <mat-select required  name="gearbox"  [(ngModel)]="currentAppointment.car.gearBox" >
                <mat-option *ngFor="let gear of carGearBoxes; index as i" [value]="gear" >{{gear}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="currentAppointment.car.version != ''">
              <mat-label >Carburant</mat-label>
              <mat-select required  name="fuel"  [(ngModel)]="currentAppointment.car.fuel" >
                <mat-option *ngFor="let fuel of carFuelTypes; index as i" [value]="fuel" >{{fuel}}</mat-option>
              </mat-select>
            </mat-form-field> -->
          </div>
        }
      </form>
    </div>

    <div class="buttons">
      <div> </div>
      <button class="simple-button-keep" mat-button matStepperNext> Suivant <mat-icon>navigate_next</mat-icon></button>
    </div>
  </mat-step>

  <mat-step [stepControl]="appointmentDetailsForm.control" [editable]="isEditable">

    <ng-template matStepLabel>
      <h3>Rendez vous</h3>
    </ng-template>

    <div class="appointment-step">
      <form #appointmentDetailsForm="ngForm" class="appointment-details" [formGroup]="jobTemplatesForm">

        <mat-form-field>
          <mat-label>Choisir une date</mat-label>
          <input required matInput [matDatepickerFilter]="filterPastDates" [matDatepicker]="picker" name="appointmentDate" [(ngModel)]="currentAppointment.appointmentDate">
          <mat-datepicker-toggle matIconSuffix [for]="picker" ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Services demandés</mat-label>
          <mat-select name="services" multiple (selectionChange)="onServiceTypeChange()" [(ngModel)]="currentAppointment.services" required>
            @for (serv of serviceTypesBD; track serv) {
              <mat-option [value]="serv.code" >{{serv.title}}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (currentAppointment.services.includes(ServiceType.REPAIR)) {
          <mat-form-field>
            <mat-label>Catégorie panne</mat-label>
            <mat-select name="jobCategories" multiple [(ngModel)]="currentAppointment.jobCategories" required>
              @for (serv of jobCategoriesBD; track serv) {
                <mat-option [value]="serv.code" >{{serv.title}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <!--
        <mat-form-field>
          <mat-label>Job Templates</mat-label>
          <input type="text"
            matInput
            formControlName="jobTemplatesGroup"
            required
            [matAutocomplete]="autoGroup">
            <mat-autocomplete #autoGroup="matAutocomplete">
              @for (group of jobTemplatesGroupOptions | async; track group) {
                <mat-optgroup [label]="group.category">
                  @for (jobTemplate of group.templates; track jobTemplate) {
                    <mat-option [value]="jobTemplate.id">{{jobTemplate.code}} - {{jobTemplate.title}}</mat-option>
                  }
                </mat-optgroup>
              }
            </mat-autocomplete>
          </mat-form-field> -->

          <mat-form-field>
            <mat-label>Job Templates</mat-label>

            <input type="text"
              matInput
              formControlName="jobTemplatesGroup"
              required
              [matAutocomplete]="autoGroup">
              <mat-autocomplete #autoGroup="matAutocomplete"  (optionSelected)='onJobTemplateSelected($event.option.value)'>

                @for (temp of currentAppointment.jobTemplates; track temp) {
                  <p>
                    {{temp.code}} - {{temp.title}} <button mat-button (click)="removeJobTemplateSelected(temp.id)"><mat-icon>delete</mat-icon></button>
                  </p>
                }
                @for (map of jobTemplatesMapOptions | async; track map[0]) {
                  <mat-optgroup> <b>{{map[0]}}</b>
                  @for (jobTemplate of map[1]; track jobTemplate) {
                    <mat-option [value]="jobTemplate">{{jobTemplate.code}} - {{jobTemplate.title}}</mat-option>
                  }
                </mat-optgroup>
              }
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Lieu du rendez vous</mat-label>
            <mat-select name="locationMode" (selectionChange)="onLocationModeChange()" [(ngModel)]="currentAppointment.locationMode" required>
              @for (loc of locationModesBD; track loc) {
                <mat-option [value]="loc.code" >{{loc.title}}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field >
            <mat-label >Message</mat-label>
            <textarea matInput type="text"  name ="details" placeholder=""  [(ngModel)]="currentAppointment.details" ></textarea>
          </mat-form-field>

          <h5>Urgence ?

            <mat-slide-toggle
              class="example-margin"
              name = "emergency"
              [disabled]="false"
              [(ngModel)]="currentAppointment.emergency"
              (change)="onEmergencyChange() ">

            </mat-slide-toggle>
          </h5>
          <!--
          <h5 *ngIf="kcService.isLoggedIn()">
            Nouvelle voiture ?
            <mat-slide-toggle
              class="example-margin"
              name = "newCar"
              [disabled]="false"
              [(ngModel)]="isNewCar"
              (change)="onNewCarChange()">

            </mat-slide-toggle>
          </h5> -->

          @if (!isNewCar) {
            <mat-form-field>
              <mat-label>Choisir provider</mat-label>
              <mat-select required name = "provider" [(ngModel)]="currentAppointment.providerId" >
                @for (prv of myKeepProviders; track prv; let i = $index) {
                  <mat-option [value]="prv.username" >
                    {{prv.civility}} {{prv.firstName}} {{prv.lastName}}, {{prv.cityResident}} - {{prv.countryResident}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </form>
      </div>

      <div class="buttons">
        <button mat-button class="simple-button-keep"  matStepperPrevious>
          Précédent <mat-icon>navigate_before</mat-icon>
        </button>

        @if (!kcService.isLoggedIn()) {
          <button class="simple-button-keep" mat-button matStepperNext>
            Suivant <mat-icon>navigate_next</mat-icon>
          </button>
        }

        @if (kcService.isLoggedIn()) {
          <button mat-button class="cta-button-keep"
            (click)="confirmAppointmentSubmit()"
            [disabled]=" !appointmentDetailsForm.valid">
            Soumettre<mat-icon>save</mat-icon>
          </button>
        }
      </div>

    </mat-step>

    @if (!kcService.isLoggedIn()) {
      <mat-step [stepControl]="customerInfosForm.control" [editable]="isEditable">
        <ng-template matStepLabel>
          <h3>Confirmer</h3>
        </ng-template>
        <div class="appointment-step">
          <h4>Informations sur le client</h4>
          <form #customerInfosForm = "ngForm" class="appointment-confirm">
            <!-- <ng-template matStepLabel>Fill out your address</ng-template> -->
            <mat-form-field >
              <mat-label>Vous etes un(e)</mat-label>
              <mat-select matNativeControl  required name = "dealerType" [(ngModel)]="currentAppointment.customerDealerType">
                @for (t of dealerTypes; track t) {
                  <mat-option [value]="t"> {{t}} </mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (currentAppointment.customerDealerType === DealerType.PROFESSIONAL) {
              <mat-form-field >
                <mat-label>Entreprise</mat-label>
                <input matInput name="customerCompany" placeholder="Entreprise" [(ngModel)]="currentAppointment.customerBusinessName">
              </mat-form-field>
            }
            <mat-form-field >
              <mat-label>Civilité</mat-label>
              <mat-select matNativeControl  required name = "civility" [(ngModel)]="currentAppointment.customerCivility">
                @for (t of civilities; track t) {
                  <mat-option [value]="t"> {{t}} </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Prénom</mat-label>
              <input  matInput name="customerFname" placeholder="Prénom" [(ngModel)]="currentAppointment.customerFirstName">
            </mat-form-field>
            <mat-form-field>
              <mat-label>Nom</mat-label>
              <input  matInput name="customerLname" placeholder="Nom"  [(ngModel)]="currentAppointment.customerLastName">
            </mat-form-field>
            <mat-form-field>
              <mat-label>Email</mat-label>
              <input  matInput name="customerEmail" placeholder="Adresse email"  [(ngModel)]="currentAppointment.customerEmail">
            </mat-form-field>
            <mat-form-field >
              <mat-label>Pays</mat-label>
              <mat-select required matNativeControl name = "countryResident" [(ngModel)]="currentAppointment.customerCountry">
                @for (country of countries; track country) {
                  <mat-option [value]="country.code"> {{country.name}} </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field >
              <mat-label>Ville</mat-label>
              <mat-select required matNativeControl name = "cityResident" [(ngModel)]="currentAppointment.customerCity">
                @for (city of getCitiesforCountry(currentAppointment.customerCountry); track city) {
                  <mat-option [value]="city"> {{city}} </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="phone-number">
              <mat-form-field >
                <mat-label>Code numero</mat-label>
                <mat-select required matNativeControl name = "phoneCode" [(ngModel)]="currentAppointment.customerPhoneNumber.code">
                  @for (country of countries; track country) {
                    <mat-option [value]="country.phoneCode"> +{{country.phoneCode}} </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field >
                <mat-label>Numéro de téléphone</mat-label>
                <input required type="number" matInput="" [pattern]="phoneNumberRegex"  name ="customerPhoneNumber"  [(ngModel)]="currentAppointment.customerPhoneNumber.number" #customerPhoneNumber="ngModel">
                @if (customerPhoneNumber.invalid && (customerPhoneNumber.dirty || customerPhoneNumber.touched)) {
                  <span class="error-alert">
                    @if (customerPhoneNumber.errors?.['required']) {
                      <span>
                        Le numéro est requis.
                      </span>
                    }
                    @if (customerPhoneNumber.errors?.['pattern']) {
                      <span>
                        Numéro non valide
                      </span>
                    }
                  </span>
                }
              </mat-form-field>
            </div>
          </form>
          <div  class="buttons">
            <!-- <button mat-button matStepperPrevious>Précédent<mat-icon>navigate_before</mat-icon></button> -->
            <!-- <button class="cta-button" mat-button (click)="confirmAppointmentSubmit()"
            [disabled]=" !customerInfosForm.valid || customerInfosForm.value.customerPhoneCode == 0 || !customerInfosForm.valid || customerInfosForm.value.mobileMoneyPhoneCode == 0 ">
            Payer et Réserver<mat-icon>save</mat-icon>
          </button> -->
          <!-- <button mat-button (click)="stepper.reset()">Annuler<mat-icon>restart_alt</mat-icon></button> -->
          <button class="simple-button-keep" mat-button matStepperPrevious >
            Précédent <mat-icon>navigate_before</mat-icon>
          </button>
          <button class="cta-button-keep" mat-button (click)="confirmAppointmentSubmit()"
            [disabled]=" !customerInfosForm.valid || customerInfosForm.value.customerPhoneCode == 0 || !customerInfosForm.valid || customerInfosForm.value.mobileMoneyPhoneCode == 0 ">
            Soumettre<mat-icon>save</mat-icon>
          </button>
        </div>
      </div>
    </mat-step>
  }
</mat-stepper>

</div>